import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GlobalService } from '../../service/global.service';

@Component({
  selector: 'app-customer-dashboard-menu',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './customer-dashboard-menu.component.html',
  styleUrl: './customer-dashboard-menu.component.scss'
})
export class CustomerDashboardMenuComponent {

  menuItem: any = [
    { name: 'My Profile', routerLink: 'userdetailPage', icon: 'fa-regular fa-user', isMenuActive: true },
    { name: 'Recharge History', routerLink: 'customer-transactions-history', icon: 'fa-solid fa-clock-rotate-left', isMenuActive: true },
    { name: 'Product Orders', routerLink: 'customer-product-order-history', icon: 'fa-solid fa-box-open', isMenuActive: true },
    { name: 'Chat History', routerLink: 'customer-chat-order-history', icon: 'fa-regular fa-comments', isMenuActive: true },
    { name: 'Call History', routerLink: 'customer-call-order-history', icon: 'fa-solid fa-phone', isMenuActive: true },
    { name: 'Wallet', routerLink: 'recharge-wallet', icon: 'fa-solid fa-wallet', isMenuActive: true },
  ];

  constructor(public gS: GlobalService) { }

  logout() {
    this.gS.LogoutUser();
  }
}
